module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/corporate-events-25109e0ec729b3b14a52827e84688ace.jpg";